module.exports = __webpack_public_path__ + "img/picture3.683e1854.png";